import { render, staticRenderFns } from "./AttendanceCorrectionsDetail.vue?vue&type=template&id=12d55800&scoped=true"
import script from "./AttendanceCorrectionsDetail.vue?vue&type=script&lang=js"
export * from "./AttendanceCorrectionsDetail.vue?vue&type=script&lang=js"
import style0 from "./AttendanceCorrectionsDetail.vue?vue&type=style&index=0&id=12d55800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d55800",
  null
  
)

export default component.exports